import { ActionIcon, Icon, Menu } from '@inflearn/ds-react-next';
import {
  faAward,
  faCircleMinus,
  faEye,
  faEyeSlash,
  faFolderPlus,
  faLink,
} from '@inflearn/pro-regular-svg-icons';
import { faEllipsis } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

import { styleShowOnlyMobile } from '../../../../../styles/commonStyle';
import { useCourseReviewContext } from '../CourseCardContainer';

export function CourseCardMenu({
  hasCertificate,
  isArchivable,
  isArchived,
  isOfflineCourse,
  isCancelable,
  courseId,
  voucherId,
  isPartners,
}: {
  hasCertificate: boolean;
  isArchivable: boolean;
  isArchived: boolean;
  isOfflineCourse: boolean;
  isCancelable: boolean;
  courseId: number;
  voucherId: number;
  isPartners: boolean;
}) {
  const { t } = useTranslation();
  const {
    openFolderModal,
    hideCourse,
    revealCourse,
    cancelCourse,
    openCertificateModal,
    copyPromotionLink,
  } = useCourseReviewContext();

  return (
    <Menu position="bottom-end" shadow="md">
      <Menu.Target>
        <ActionIcon size="n-md" variant="subtle" color="gray">
          <Icon icon={faEllipsis} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {!isOfflineCourse && hasCertificate && (
          <Menu.Item
            icon={<Icon icon={faAward} size="sm" fixedWidth />}
            onClick={() => openCertificateModal(voucherId)}
            styles={{
              item: { ...styleShowOnlyMobile },
            }}
          >
            {t('수료증 보기')}
          </Menu.Item>
        )}

        {isCancelable && (
          <Menu.Item
            icon={<Icon icon={faCircleMinus} size="sm" fixedWidth />}
            onClick={() => cancelCourse(voucherId)}
          >
            {t('수강 취소')}
          </Menu.Item>
        )}

        {!isArchived && isArchivable && (
          <Menu.Item
            icon={<Icon icon={faEyeSlash} size="sm" fixedWidth />}
            onClick={() => hideCourse(voucherId)}
          >
            {t('강의 숨기기')}
          </Menu.Item>
        )}

        {isArchived && (
          <Menu.Item
            icon={<Icon icon={faEye} size="sm" fixedWidth />}
            onClick={() => revealCourse(voucherId)}
          >
            {t('숨김 취소')}
          </Menu.Item>
        )}

        <Menu.Item
          icon={<Icon icon={faFolderPlus} size="sm" fixedWidth />}
          onClick={() => openFolderModal(courseId)}
        >
          {t('폴더에 추가')}
        </Menu.Item>

        {isPartners && !isOfflineCourse && (
          <Menu.Item
            icon={<Icon icon={faLink} size="sm" fixedWidth />}
            onClick={() => copyPromotionLink(voucherId)}
          >
            {t('홍보 링크 복사')}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
